import { useTranslation } from 'react-i18next';
import { Droplets, Fan } from 'lucide-react';
import type { ModalitaVmc } from '@emacomfort/domain';
import { useComando, useDevice, useObsoleto, useStato } from '@/app/DeviceProvider';
import { useFormato } from '@/app/formato';
import { Avviso, Badge, Card, Pagina, Segmenti, StatoComandoVista, Valore } from '@/ui';
import { useAttuatore, useCanalePerFunzione, useValoreFunzione } from '../comune';
import s from '../features.module.css';

const MODALITA: ModalitaVmc[] = ['SPENTA', 'ACCESA', 'AUTO'];

export function VentilazionePage() {
  const { t } = useTranslation();
  const f = useFormato();
  const { invia } = useDevice();
  const impianto = useStato((st) => st.impianto);
  const vmc = useStato((st) => st.stato?.vmc);
  const { obsoleto } = useObsoleto();
  const umidita = useValoreFunzione('UMIDITA_INTERNA');
  const canale = useCanalePerFunzione('VMC');
  const attuatore = useAttuatore(canale?.id);
  const comando = useComando('vmc');
  const richiesta = comando && comando.esito !== 'fallito' && comando.azione.azione === 'set_vmc' ? comando.azione.modalita : null;

  if (!impianto) return null;
  if (!impianto.vmc.presente) {
    return (
      <Pagina titolo={t('vmc.titolo')}>
        <Avviso tono="info">{t('vmc.nonPresente')}</Avviso>
      </Pagina>
    );
  }
  const attiva = !obsoleto && attuatore?.stato === 'attivo';
  return (
    <Pagina titolo={t('vmc.titolo')}>
      <div className={s.grigliaDue}>
        <Card titolo={t('vmc.titolo')} icona={<Fan size={20} aria-hidden />}>
          <Segmenti etichetta={t('vmc.titolo')} valore={richiesta ?? vmc?.modalita ?? impianto.vmc.modalita} onChange={(m) => void invia({ azione: 'set_vmc', modalita: m })} opzioni={MODALITA.map((m) => ({ valore: m, etichetta: t(`vmc.modalita.${m}`) }))} disabilitato={obsoleto} />
          <div className={s.letturaRiga}>
            <Badge tono={attiva ? 'ok' : 'neutro'}>{attiva ? t('vmc.attiva') : t('vmc.inattiva')}</Badge>
            {attiva && attuatore?.modulazione !== undefined && <span className={s.letturaNota}>{f.pct(attuatore.modulazione)}</span>}
          </div>
          <StatoComandoVista esito={comando?.esito} motivo={comando?.motivo} />
        </Card>
        <Card titolo={t('vmc.umidita')} icona={<Droplets size={20} aria-hidden />}>
          <Valore numero={umidita.valore === null ? '— —' : f.pct(umidita.valore)} dimensione="primario" obsoleto={umidita.obsoleto} />
          {umidita.q === 'sonda_scollegata' && <Avviso tono="warn">{t('stato.sondaScollegata')}</Avviso>}
          <p className={s.letturaNota}>{t('vmc.soglia', { pct: impianto.vmc.sogliaUmidita })}</p>
        </Card>
      </div>
    </Pagina>
  );
}
